import axios from 'axios';

// Set base URL for all requests
axios.defaults.baseURL = 'https://dilimedcenter.com/';

// Add a request interceptor to add auth token
axios.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// Handle common responses
axios.interceptors.response.use(
  response => response,
  error => {
    // Handle unauthorized error
    if (error.response && error.response.status === 401 && error.response.data.message === 'Unauthorized' && error.response.data.error === 'Token expired' && error.response.data.status === 403) {
      localStorage.removeItem('token');
      // Optional: redirect to login page
      // window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default axios;
